export const GOOGLE_CALENDAR_SELECTED = 'GOOGLE_CALENDAR_SELECTED';
export default GOOGLE_CALENDAR_SELECTED;
